import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { PartnerService } from '../../core/services/partner.service';
import { Partner } from '../../shared/interfaces/partner.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationFormComponent } from '../../shared/components/registration-form/registration-form.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatSnackBarModule,
    RegistrationFormComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  private readonly urlGoogle =
    'https://play.google.com/store/apps/details?id=br.com.alphacode.madero&hl=pt_BR&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
  private readonly urlApple =
    'https://apps.apple.com/br/app/grupo-madero-app/id1579688707?l=en';
  private readonly urPrivacy =
    'https://madero.blob.core.windows.net/fidelidade/Documentos/Politica_de_Privacidade_Madero_Cashback.pdf';
  private readonly urTerms =
    'https://madero.blob.core.windows.net/fidelidade/Documentos/Regulamento_Madero_Cashback.pdf';
  private readonly urlPartner =
    'https://madero.blob.core.windows.net/fidelidade/Documentos/termos-parceiros.pdf';

  imagePartner = '';
  partnerActive!: Partner;
  binActive = false;
  classRed = false;

  constructor(
    private snackBar: MatSnackBar,
    private partnerService: PartnerService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.onMonitoringRouter();
  }

  onMonitoringRouter(): void {
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams['partner']) {
      this.onGetPartner(queryParams['partner']);
    } else {
      this.router.navigate(['/not-found']);
    }
  }

  onGetPartner(partnerId: string): void {
    if (partnerId == '4mN3kZO14r') {
      this.classRed = true;
    }
    this.partnerService.getPartner(partnerId).subscribe({
      next: (response) => {
        if (response?.name === 'GrupoMadero') {
          this.router.navigate(['/register'], {
            queryParams: { partner: partnerId },
          });
          return;
        }

        this.imagePartner = `${response.logoBase64}`;
        this.partnerActive = response;
        response.fields.map((field: any) => {
          if (field.id === '005') {
            this.binActive = true;
          }
        });
        if (!response?.benefitAvailable) {
          this.router.navigate(['/not-found']);
        }
      },
      error: (err) => {
        console.log('Erro ao buscar a empresa!');
        this.router.navigate(['/not-found']);
      },
    });
  }

  scrollToBotton(): void {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  }

  onRedirect(nameLink: string): void {
    switch (nameLink) {
      case 'google':
        window.open(this.urlGoogle, '_blank');
        break;
      case 'apple':
        window.open(this.urlApple, '_blank');
        break;
      case 'terms':
        window.open(this.urTerms, '_blank');
        break;
      case 'privacy':
        window.open(this.urPrivacy, '_blank');
        break;
      case 'partner':
        window.open(this.urlPartner, '_blank');
        break;
      default:
        break;
    }
  }
}
